import React from 'react';

interface QuickFitProps {
  quickFitText: string;
  showFitPrefix?: boolean;
  tabIndex?: number;
}

const QuickFit = ({ quickFitText, showFitPrefix = true, tabIndex }: QuickFitProps) => {
  return (
    <p className="quickFitText body" {...(tabIndex !== undefined ? { tabIndex } : {})}>
      {showFitPrefix && <span className="body bold mr-2">Fit:</span>}
      {quickFitText}
    </p>
  );
};

export default QuickFit;
